import {CheckoutEventsItem} from "@paddle/paddle-js";
import intl from "react-intl-universal";

import {getPriceItemById, SUBSCRIPTION_ITEM, SUBSCRIPTION_ITEMS} from "../subscription_plans";


export const getLocalItemName = (item: CheckoutEventsItem) => {
    const priceItem = getPriceItemById(item.price_id);
    const name = getLocalSubscriptionItemName(priceItem);
    if (name !== undefined) {
        return name;
    }
    return item.product.name;
}

export const getLocalSubscriptionItemName = (priceItem: SUBSCRIPTION_ITEM) => {
    switch (priceItem) {
        case SUBSCRIPTION_ITEMS.STANDARD:
            return intl.get('checkout.check-plan-standard').d('Standard plan');
        case SUBSCRIPTION_ITEMS.LOCATION_SLOT:
            return intl.get('checkout.location_slots').d('Location slots');
        case SUBSCRIPTION_ITEMS.USER_SEAT:
            return intl.get('checkout.additional_users').d('User seats');
    }
}
